import React, { useState ,useCallback , useEffect} from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import {  useNavigate } from "react-router-dom";
import { StripeCheckout } from "../../api/stripeCheckout.js";
import { getDecryptedBatch } from "../../utils/cryptoUtils.js";

export default function QuillionzProUpgradeModal({ isOpen, onClose }) {
  // Add a new state variable to track the loading state
  const [isLoading, setIsLoading] = React.useState(false);
  const navigate = useNavigate();
  
  // ── Encrypted localStorage values — live in state ─────────────────────────
  const [userId, setUserId]     = useState("");
  const [email, setEmail]       = useState("");


  // ── Decrypt on mount ──────────────────────────────────────────────────────
  useEffect(() => {
    const loadSecureData = async () => {
      const {
        Id:    decryptedId,
        email: decryptedEmail,
      } = await getDecryptedBatch(["Id", "email"]);

      setUserId(decryptedId ?? "");
      setEmail(decryptedEmail ?? "");
    };

    loadSecureData();
  }, []);

  // Function to handle closing the modal
  const handleModalClose = () => {
    onClose(); // Close the modal
    // Do any other logic you need before redirecting to "/"
  };

  const handleNavigate = () =>{
   navigate('/userinfo')
  }

    const handleBuyMonthly = useCallback(async (e) => {
      try {
        setIsLoading(true);
  
        // Read user info from localStorage (common keys)
        const userid =
          localStorage.getItem("Id") ||
          localStorage.getItem("Userid") ||
          localStorage.getItem("userid") ||
          localStorage.getItem("userId") ||
          null;
        const Email =
          localStorage.getItem("email") ||
          localStorage.getItem("Email") ||
          localStorage.getItem("userEmail") ||
          "";
        const Firstname =
          localStorage.getItem("firstname") ||
          localStorage.getItem("Firstname") ||
          localStorage.getItem("username") ||
          "";
        const Lastename =
          localStorage.getItem("lastname") || localStorage.getItem("Lastename") || "";
  
        if (!userid || !Email) {
          alert("Missing user information. Please login before purchasing.");
          setIsLoading(false);
          return;
        }
  
        // Call backend API helper. The helper should POST and return response.
        const resp = await StripeCheckout(userid, Email, Firstname, Lastename);
  
        // The backend may return { url: '...' } inside resp.data or resp directly
        const url =
          resp?.data?.url || // axios response with data.url
          resp?.url || // direct returned object
          (resp && typeof resp === "string" ? resp : null);
  
        if (!url) {
          console.error("Stripe checkout did not return a url:", resp);
          alert("Unable to start checkout. Try again later.");
          setIsLoading(false);
          return;
        }
  
        // redirect to Stripe hosted checkout
        window.location.href = url;
      } catch (err) {
        console.error("Error starting Stripe checkout:", err);
        const msg =
          (err && err.message) ||
          (err?.response && (err.response.data?.error || err.response.data?.message)) ||
          "Checkout failed";
        alert(`Checkout failed: ${msg}`);
      } finally {
        setIsLoading(false);
      }
    }, []);
  
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={isOpen}
        onClose={onClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
        className="bg-[00000080]"
      >
        <Fade in={isOpen}>
          <Box
            sx={{
              position: "fixed",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="bg-white shadow-2xl rounded-lg animate-fade-slide-down w-max max-w-md">
              <div className="flex place-content-between mx-2 p-3 border-b">
                <h2 className="text-lg font-semibold text-center">
                  Subscription Required
                </h2>
                <Tooltip
                  title="Close"
                  arrow
                  placement="top"
                  TransitionComponent={Zoom}
                  TransitionProps={{ timeout: 300 }}
                >
                  <button
                    className="text-[#6c757d] text-lg hover:bg-[#edeeef] px-2 rounded-full"
                    onClick={handleModalClose}
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </Tooltip>
              </div>

              {/* Subscription Message */}
              <div className="text-center px-8 py-10">
                <div className="mb-8">
                  {/* Icon with gradient background */}
                  <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 shadow-lg mb-6">
                    <i className="fa-solid fa-crown text-4xl text-white"></i>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-800 mb-3">
                    Unlock Premium Access
                  </h3>
                  
                  <p className="text-gray-600 text-base leading-relaxed max-w-sm mx-auto">
                    Subscribe to a paid plan to submit content and access all premium features.
                  </p>
                </div>

                {/* Features list */}
                {/* <div className="mb-8 text-left max-w-xs mx-auto space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center">
                      <i className="fa-solid fa-check text-green-600 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-sm">Submit content</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center">
                      <i className="fa-solid fa-check text-green-600 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-sm">Access premium features</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center">
                      <i className="fa-solid fa-check text-green-600 text-sm"></i>
                    </div>
                    <span className="text-gray-700 text-sm">Priority support</span>
                  </div>
                </div> */}

                <button
                  type="button"
                  onClick={handleNavigate}
                  className="px-8 py-3 rounded-full text-white font-semibold shadow-lg bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
                >
                  View Subscription Plans
                  <i className="fa-solid fa-arrow-right ml-2"></i>
                </button>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
